var React = require('react');

function PlusSign (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-606 -543) translate(574 513) translate(32 30)"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#E25886","key":0}),React.createElement("g",{"stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},React.createElement("path",{"d":"M7 0L7 14M0 7L14 7","transform":"rotate(90 7 16)"}))])))));
}

PlusSign.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = PlusSign;

PlusSign.default = PlusSign;
